var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTermination = function SvgTermination(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1854_8021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 30.9016H30.5141V34.0983H0V30.9016Z",
    fill: "#152A58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2716 65H21.1418C15.2569 65 10.4619 60.5245 10.4619 55.1967V42.4099H13.7313V55.1967C13.7313 58.8197 17.0007 61.8033 21.1418 61.8033H54.2716C58.4127 61.8033 61.6822 58.8197 61.6822 55.1967V9.80329C61.6822 6.18033 58.4127 3.19671 54.2716 3.19671H21.1418C17.0007 3.19671 13.7313 6.18033 13.7313 9.80329V22.5901H10.4619V9.80329C10.4619 4.47541 15.2569 0 21.1418 0H54.2716C60.1564 0 64.9515 4.47541 64.9515 9.80329V55.1967C64.9515 60.5245 60.1564 65 54.2716 65Z",
    fill: "#152A58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1416 43.9016L18.7441 41.5574L28.3343 32.3934L18.7441 23.2294L21.1416 20.8853L32.9113 32.3934L21.1416 43.9016Z",
    fill: "#152A58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1854_8021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })))));
};
export default SvgTermination;